import MuiTextField, { TextFieldProps } from '@mui/material/TextField';

// @local
import toFormField from '../to-form-field';

export const TextInput = (props: TextFieldProps) => <MuiTextField {...props} />;

export default toFormField(TextInput);
